import type { ContractRecord } from '../../domain/contract'

/** Données de démonstration explicitement fictives. */
export const contractsFixtures: ContractRecord[] = [
  {
    id: 'ctr-0000-4000-8000-000000000001',
    number: 'CTR-2026-014',
    markerState: 'IN_PLACE',
    status: 'ACTIVE',
    clientId: 'cli-0000-4000-8000-000000000001',
    clientDisplayName: 'Diane Laviolette',
    clientNumber: 'CLI-000083',
    type: 'deneigement',
    season: '2026-2027',
    priceCents: 189000,
    signedOn: '2026-07-12',
    startsOn: '2026-11-01',
    endsOn: '2027-04-15',
    renewal: true,
    measurementMode: 'SATELLITE',
    notes: 'Entrée asphaltée, contourner la borne à droite.',
    createdAt: '2026-07-12T14:00:00Z',
    updatedAt: '2026-08-01T09:30:00Z',
  },
  {
    id: 'ctr-0000-4000-8000-000000000002',
    number: 'CTR-2026-015',
    status: 'PENDING',
    clientId: 'cli-0000-4000-8000-000000000002',
    clientDisplayName: 'Groupe Ferland',
    clientNumber: 'CLI-000084',
    type: 'deneigement',
    season: '2026-2027',
    priceCents: 845000,
    startsOn: '2026-11-01',
    endsOn: '2027-04-15',
    renewal: false,
    measurementMode: 'NONE',
    standardDrivewayCapacity: 2,
    createdAt: '2026-08-02T10:00:00Z',
    updatedAt: '2026-08-08T16:20:00Z',
  },
  {
    id: 'ctr-0000-4000-8000-000000000003',
    number: 'CTR-2025-201',
    status: 'EXPIRED',
    clientId: 'cli-0000-4000-8000-000000000003',
    clientDisplayName: 'Sophie Nadeau',
    clientNumber: 'CLI-000061',
    type: 'deneigement',
    season: '2025-2026',
    priceCents: 165000,
    signedOn: '2025-08-20',
    startsOn: '2025-11-01',
    endsOn: '2026-04-15',
    renewal: false,
    measurementMode: 'NONE',
    standardDrivewayCapacity: 1,
    createdAt: '2025-08-20T11:00:00Z',
    updatedAt: '2026-04-16T08:00:00Z',
  },
  {
    id: 'ctr-0000-4000-8000-000000000004',
    number: 'CTR-2026-016',
    status: 'ACTIVE',
    clientId: 'cli-0000-4000-8000-000000000004',
    clientDisplayName: 'Marcel Gauthier',
    clientNumber: 'CLI-000090',
    type: 'deneigement',
    season: '2026-2027',
    priceCents: 142000,
    startsOn: '2026-11-01',
    endsOn: '2027-04-15',
    renewal: false,
    measurementMode: 'NONE',
    standardDrivewayCapacity: 1,
    // Envoyé pour signature, jamais ouvert depuis : carte « En attente de signature ».
    sentAt: '2026-10-01T13:00:00Z',
    lastSentAt: '2026-10-01T13:00:00Z',
    createdAt: '2026-09-30T10:00:00Z',
    updatedAt: '2026-10-01T13:00:00Z',
  },
  {
    id: 'ctr-0000-4000-8000-000000000005',
    number: 'CTR-2026-017',
    status: 'ACTIVE',
    clientId: 'cli-0000-4000-8000-000000000005',
    clientDisplayName: 'Lucie Tremblay',
    clientNumber: 'CLI-000091',
    type: 'deneigement',
    season: '2026-2027',
    priceCents: 158000,
    startsOn: '2026-11-01',
    endsOn: '2027-04-15',
    renewal: false,
    measurementMode: 'NONE',
    standardDrivewayCapacity: 1,
    // Relancé puis rouvert par le client : carte « En attente de signature (Ouvert) ».
    sentAt: '2026-09-28T13:00:00Z',
    lastSentAt: '2026-10-02T13:00:00Z',
    lastViewedAt: '2026-10-03T09:15:00Z',
    openedSinceLastSend: true,
    createdAt: '2026-09-27T10:00:00Z',
    updatedAt: '2026-10-03T09:15:00Z',
  },
  // Contrats vNext : portefeuille de démonstration « Gestion immobilière Laurentides » (30 adresses), même
  // identifiant que `src/features/contracts-vnext/infrastructure/fixtures/vnextDemoData.ts`.
  {
    id: '00000000-0000-4000-a000-00000000d014',
    number: 'MLT-00014',
    status: 'PENDING',
    clientId: 'cli-0000-4000-8000-000000000014',
    clientDisplayName: 'Gestion immobilière Laurentides',
    clientNumber: 'CLI-002418',
    clientPhone: '450 555-0142',
    clientEmail: 'megagnon@gil-immo.example',
    type: 'deneigement',
    season: '2026-2027',
    priceCents: 4_205_000,
    startsOn: '2026-11-01',
    endsOn: '2027-04-15',
    renewal: false,
    measurementMode: 'NONE',
    submissionType: 'COMMERCIAL',
    sentAt: '2026-10-21T15:30:00Z',
    billingAddress: {
      name: 'Gestion immobilière Laurentides',
      line1: '200, rue De Martigny Ouest, bureau 410',
      city: 'Saint-Jérôme',
      province: 'QC',
      postalCode: 'J7Y 2G1',
    },
    createdAt: '2026-10-20T14:00:00Z',
    updatedAt: '2026-10-21T15:30:00Z',
  },
]
